import React from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { RevelationSection } from './components/RevelationSection';
import { AboutSection } from './components/AboutSection';
import { InterventionSection } from './components/InterventionSection';
import { OfferSection } from './components/OfferSection';
import { BonusSection } from './components/BonusSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FAQSection } from './components/FAQSection';
import { ClosingSection } from './components/ClosingSection';
export function App() {
  return <main className="min-h-screen bg-dark font-sans text-textLight" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <RevelationSection data-id="element-3" />
      <AboutSection data-id="element-4" />
      <InterventionSection data-id="element-5" />
      <OfferSection data-id="element-6" />
      <BonusSection data-id="element-7" />
      <TestimonialsSection data-id="element-8" />
      <FAQSection data-id="element-9" />
      <ClosingSection data-id="element-10" />
    </main>;
}